(function () {
  var debounceId;

  function scheduleUpdate() {
    clearTimeout(debounceId);
    debounceId = setTimeout(updateAll, 0);
  }

  function formatMoney(cents) {
    if (window.T4SThemeSP && T4SThemeSP.Currency && typeof T4SThemeSP.Currency.formatMoney === 'function') {
      return T4SThemeSP.Currency.formatMoney(cents);
    }
    return String(Math.round(Number(cents) / 100));
  }

  function sortTiers(t1, t2, t3) {
    return [t1, t2, t3]
      .map(function (n) {
        var x = Number(n);
        return isNaN(x) ? 0 : x;
      })
      .sort(function (a, b) {
        return a - b;
      });
  }

  function percentClassForBar(percentW2, cfg) {
    var tiers = sortTiers(cfg.tier1, cfg.tier2, cfg.tier3);
    var n0 = tiers[0];
    var n1 = tiers[1];
    var n2 = tiers[2];
    var less100 = cfg.less100;
    var pc;
    if (percentW2 < n0) pc = n0;
    else if (percentW2 < n1) pc = n1;
    else if (percentW2 < n2) pc = n2;
    else pc = 99.994;
    if (pc === 100) pc = less100;
    return String(pc);
  }

  function buildMessage(total, threshold, cfg) {
    var tpl1 = cfg.tpl1 || '';
    var tpl2 = cfg.tpl2 || '';
    var m50 = cfg.m50 || '';
    var m75 = cfg.m75 || '';
    var m100 = cfg.m100 || '';
    if (total === 0) {
      return {
        html: tpl1.split('__M__').join(formatMoney(threshold)),
        wrapClass: 't4s-cart__thres1',
        done: false,
      };
    }
    if (total >= threshold) {
      return {
        html: m100,
        wrapClass: 't4s-cart__thres3 t4s-cart__gafas-peak',
        done: true,
      };
    }
    if (total * 4 >= threshold * 3) {
      return {
        html: m75,
        wrapClass: 't4s-cart__thres2 t4s-cart__gafas-milestone',
        done: false,
      };
    }
    if (total * 2 >= threshold) {
      return {
        html: m50,
        wrapClass: 't4s-cart__thres2 t4s-cart__gafas-milestone',
        done: false,
      };
    }
    var remain = threshold - total;
    return {
      html: tpl2.split('__M__').join(formatMoney(remain)),
      wrapClass: 't4s-cart__thres2',
      done: false,
    };
  }

  function updateOneWrap(wrap) {
    var jsonEl = wrap.querySelector('script[data-cart-gafas-i18n]');
    if (!jsonEl) return;
    var cfg;
    try {
      cfg = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    var threshold = parseInt(cfg.threshold, 10);
    if (!threshold || threshold < 1) return;

    var textEl = wrap.querySelector('[data-cart-gafas-text]');
    var barEl = wrap.querySelector('[data-cart-gafas-bar]');
    if (!textEl || !barEl) return;

    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var total = cart.total_price || 0;
        var msg = buildMessage(total, threshold, cfg);
        textEl.className = msg.wrapClass;
        textEl.innerHTML = msg.html;
        if (msg.done) textEl.setAttribute('data-cart-gafas-done', '');
        else textEl.removeAttribute('data-cart-gafas-done');

        var tiers = sortTiers(cfg.tier1, cfg.tier2, cfg.tier3);
        var less100 = cfg.less100;

        if (total === 0) {
          var p0 = tiers[0];
          if (p0 === 100) p0 = less100;
          wrap.setAttribute('data-t4s-percent', String(p0));
          barEl.setAttribute('style', 'width:0%');
          return;
        }

        if (total >= threshold) {
          wrap.setAttribute('data-t4s-percent', '100');
          barEl.setAttribute('style', 'width:100%');
          return;
        }

        var percentW2 = 100 - ((threshold - total) * 100) / threshold;
        var pc = percentClassForBar(percentW2, cfg);
        wrap.setAttribute('data-t4s-percent', pc);
        barEl.setAttribute('style', 'width:' + Math.max(0, Math.min(100, percentW2)) + '%');
      })
      .catch(function () {});
  }

  function updateAll() {
    document.querySelectorAll('[data-cart-calc-gafas]').forEach(updateOneWrap);
  }

  function fetchUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartMutationUrl(url) {
    try {
      var path = String(url).split('?')[0];
      return /\/cart\/(change|add|update|clear)(\.js)?$/i.test(path);
    } catch (e) {
      return false;
    }
  }

  if (typeof window.fetch === 'function') {
    var realFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = fetchUrl(input);
      return realFetch.apply(this, arguments).then(function (res) {
        if (res.ok && isCartMutationUrl(url)) scheduleUpdate();
        return res;
      });
    };
  }

  document.addEventListener('DOMContentLoaded', updateAll);
  document.addEventListener('cart:refresh', scheduleUpdate);
  document.addEventListener('cart:refresh:opend', scheduleUpdate);
  document.addEventListener('cart:updated', scheduleUpdate);
})();
